<template>
  <div class="player-detail-container">
    <el-tabs v-model="activeName" type="card" >
      <el-tab-pane label="基本信息" name="first">
        <el-form v-if="player" class="user-from" label-width="140px" >
          <el-form-item class="label-line-height" label="上传头像" >
            <el-upload
              :on-success="handleSuccess"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              class="upload-size"
              list-type="picture-card">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="player.profile | ImageFormats" alt="img"></div>
                <img v-show="player.profile" slot="reference" :src="player.profile | ImageFormats" >
              </el-popover>
              <i v-show="!player.profile" class="el-icon-plus avatar-uploader-icon"/>
              <div slot="tip" class="el-upload__tip"><span>会员审核只支持上传标准证件照，建议不超过5Mb </span><span>
              <el-tooltip class="reason-item" content="头像应为证件照" placement="top">
                <i class="el-icon-warning-outline" @click="appendRemarkReason('头像应为证件照')"></i>
              </el-tooltip>
              </span></div>
            </el-upload>
          </el-form-item>
          <el-form-item label="用户姓名">
            <el-input v-model="player.trueName" />
          </el-form-item>
          <el-form-item label="性别" >
            <el-radio v-model="player.gender" label="男">男</el-radio>
            <el-radio v-model="player.gender" label="女">女</el-radio>
          </el-form-item>
          <el-form-item label="国籍">
            <el-select v-model="player.nationality" filterable placeholder="请选择国籍">
              <el-option label="中国" value="中国"/>
              <el-option label="其他" value="其他"/>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期" >
            <el-date-picker
              v-model="player.birthday"
              type="date"
              placeholder="选择日期时间"/>
          </el-form-item>
          <el-form-item label="证件类型">
            <el-select v-model="player.certificateType" filterable placeholder="身份证" @change="confirmCertificateType">
              <el-option v-for="item in certificateType" :key="item.id" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码">
            <el-input v-model="player.certificateNum" />
          </el-form-item>
          <el-form-item label="证件有效期" >
            <el-date-picker
              v-model="expiredDate"
              type="date"
              placeholder="选择有效期时间"/>
              <el-tooltip class="reason-item" content="身份证已过期" placement="top">
                <i class="el-icon-warning-outline" @click="appendRemarkReason('身份证已过期')"></i>
              </el-tooltip>
          </el-form-item>
          <el-form-item label="证件正面">
            <el-upload
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              :on-success="handleCertificateFront"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              class="upload-demo">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="player.certificateFrontImg | ImageCertFormats" alt="img"></div>
                <img v-show="player.certificateFrontImg" slot="reference" :src="player.certificateFrontImg | ImageFormats" class="certificate-upload-style" >
              </el-popover>
              <div v-show="!player.certificateFrontImg" class="certificate-upload-style" >
                选择上传文件
              </div>
              <div slot="tip" class="el-upload__tip"><span>注：请上传运动员身份证正反面照片，并底衬A4纸附监护人/本人（16岁以上）签名 </span></span><el-tooltip class="reason-item" content="身份证需附监护人/本人（16岁以上）签字" placement="top">
                <i class="el-icon-warning-outline" @click="appendRemarkReason('身份证需附监护人/本人（16岁以上）签字')"></i>
              </el-tooltip></span></div>
            </el-upload>
          </el-form-item>
          <el-form-item label="证件反面">
            <el-upload
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              :on-success="handleCertificateBack"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              class="upload-demo">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="player.certificateBackImg | ImageCertFormats" alt="img"></div>
                <img v-show="player.certificateBackImg" slot="reference" :src="player.certificateBackImg | ImageFormats" class="certificate-upload-style" >
              </el-popover>
              <div v-show="!player.certificateBackImg" class="certificate-upload-style" >
                选择上传文件
              </div>
              <div slot="tip" class="el-upload__tip"><span>注：请上传运动员身份证正反面照片，并底衬A4纸附监护人/本人（16岁以上）签名 </span>
              <span>
              <el-tooltip class="reason-item" content="身份证需附监护人/本人（16岁以上）签字" placement="top">
                <i class="el-icon-warning-outline" @click="appendRemarkReason('身份证需附监护人/本人（16岁以上）签字')"></i>
              </el-tooltip>
              </span>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="身高(CM)">
            <el-input v-model="player.high" />
          </el-form-item>
          <el-form-item label="体重(KG)">
            <el-input v-model="player.weight" />
          </el-form-item>
          <el-form-item label="持杆方式" >
            <el-radio v-model="player.stickHand" label="左手杆">左手杆</el-radio>
            <el-radio v-model="player.stickHand" label="右手杆">右手杆</el-radio>
          </el-form-item>
          <el-form-item label="是否出国" >
            <el-radio-group v-model="player.isAbroad">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="出国日期" v-if="player.isAbroad === 1">
            <el-date-picker
              v-model="player.abroadDate"
              type="date"
              placeholder="选择日期时间"/>
          </el-form-item>
          <el-form-item label="学生类型" >
            <el-radio v-model="player.category" label="北京学生">北京学生</el-radio>
            <el-radio v-model="player.category" label="外地学生">外地学生</el-radio>
            <el-radio v-model="player.category" label="学龄前儿童">学龄前儿童</el-radio>
            <el-radio v-model="player.category" label="成人">成人</el-radio>
          </el-form-item>
          <el-form-item label="就读年级">
            <el-select v-model="player.schoolGrade" clearable placeholder="请选择年级" style="width: 300px">
              <el-option v-for="item in schoolGradeList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="教育背景">
            <el-input
              :rows="2"
              v-model="player.educationSummary"
              type="textarea"
              placeholder="请输入教育背景简介"/>
          </el-form-item>
          <el-form-item label="再次注册年度" >
            <el-input v-model="player.membershipYear" disabled />
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link font-size-style">
                历史注册年度<i class="el-icon-arrow-down el-icon--right"/>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in historyYears" :key="item.year">{{ item.year }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item label="注册地">
            <el-select v-model="player.area" filterable placeholder="请选择" style="width: 300px">
              <el-option v-for="(item, index) in areaList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="请选择渠道">
            <el-select v-model="player.source" filterable placeholder="请选择" style="width: 300px">
              <el-option v-for="(item, index) in sourceList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="player.source==sourceList[3]" label="请填写其他渠道">
            <el-input
              :rows="2"
              v-model="player.otherSource"
              type="textarea"
              placeholder="请输入"/>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-player-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>

      </el-tab-pane>
      <el-tab-pane label="冰球水平" name="second">
        <el-form v-if="player" label-width="96px" class="lce-hockey-level" >
          <el-form-item label="场上位置" >
            <el-radio v-model="player.position" label="前锋">前锋</el-radio>
            <el-radio v-model="player.position" label="后卫">后卫</el-radio>
            <el-radio v-model="player.position" label="守门员">守门员</el-radio>
          </el-form-item>
          <el-form-item label="队服号码">
            <el-input v-model="player.jerseyNo" type="number" />
          </el-form-item>
          <el-form-item label="现任教练">
            <el-select v-model="player.coachId" filterable placeholder="选择教练">
              <el-option v-for="item in coachList" :key="item.id" :label="item.trueName" :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="运动等级">
            <el-select v-model="player.sportsLevel" clearable placeholder="选择运动等级">
              <el-option v-for="item in sportsLevelList" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item v-if="player.sportsLevel" class="label-line-height" label="运动等级证书" >
            <el-upload
              :on-success="handleSportsLevelImgSuccess"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              class="upload-size"
              list-type="picture-card">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="player.sportsLevelImg | ImageCertFormats" alt="img"></div>
                <img v-show="player.sportsLevelImg" slot="reference" :src="player.sportsLevelImg | ImageFormats" >
              </el-popover>
              <i v-show="!player.sportsLevelImg" class="el-icon-plus avatar-uploader-icon"/>
              <div slot="tip" class="el-upload__tip">上传运动等级证书</div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-player-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>
      </el-tab-pane>

    <el-tab-pane label="北京青少年队入选经历" name="forth">
        <div class="add">
          <el-select v-model="year" style="width: 120px; margin-right: 10px;" placeholder="请选择年度">
            <el-option
              v-for="item in yearOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>

          <el-select v-model="teamId" style="width: 200px; margin-right: 10px" placeholder="请选择球队">
            <el-option
              v-for="item in teamList"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>

          <el-button type="primary" @click="addPlayerExperience">添 加</el-button>
        </div>
        <div class="table">
          <el-table
            :data="list"
            border
            style="width: 600px; margin-top: 20px">
            <el-table-column
              prop="year"
              label="年度"
              width="120"/>
            <el-table-column
              prop="name"
              label="队名"/>
            <el-table-column
              label="操作"
              width="120">
              <template slot-scope="{row}">
                <el-link type="danger" @click="deleteExperience(row)">删 除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>

      <el-tab-pane label="会员单位" name="sixth">
        <div class="add" style="display: flex; align-items: center;">
          <el-select v-model="enterOrganizationYear" style="width: 160px; margin-right: 10px;" placeholder="选择入驻年度">
            <el-option
              v-for="item in yearOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>

          <el-select
              v-model="enterOrganizationId"
              filterable
              placeholder="选择会员单位"
              style="
                width: 300px; margin-right: 10px;
              ">
              <el-option v-for="item in organizationList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          <el-button :disabled="!(enterOrganizationYear && enterOrganizationId)" type="primary" @click="addPlayerOrganization">添 加</el-button>
        </div>
        <div class="table">
          <el-table
            :data="myOrganizationList"
            border
            style="width: 542px; margin-top: 20px">
            <el-table-column
              prop="enterOrganizationYear"
              label="入驻年度" width="120px"/>
            <el-table-column
              prop="organizationName"
              label="会员单位名称"
              width="300px"/>
            <el-table-column
              label="操作"
              width="120">
              <template slot-scope="{row}">
                <el-link type="danger" @click="deletePlayerOrganization(row)">删 除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table">
          <el-table
            :data="myGroupList"
            border
            style="width: 942px; margin-top: 20px">
            <el-table-column
              prop="season"
              label="赛季年度" 
              width="80px"/>
            <el-table-column
              prop="organizationName"
              label="会员单位名称"
              width="300px"/>
            <el-table-column
              prop="leagueName"
              label="联盟名称" 
              width="160px"/>
            <el-table-column
              prop="groupName"
              label="赛事组别" 
              width="160px"/>
            <el-table-column
              prop="clubTeamName"
              label="球队名称" 
              width="160px"/>
            <el-table-column
              label="参赛成绩"
              width="80px">
              <template slot-scope="{row}">
                <span>{{ row.result | resultFormatter }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>

      <el-tab-pane label="联系方式" name="third">
        <el-form label-width="96px" class="hockey-contact" >
          <el-form-item label="电子邮箱" >
            <el-input v-model="player.email" />
          </el-form-item>

          <div v-for="(item, index) in guardians" :key="index" class="guardians" >
            <el-form-item label="监护人">
              <el-input v-model="item.name" />
            </el-form-item>
            <el-form-item label="证件类型">
              <el-select v-model="item.certificateType" filterable placeholder="身份证" @change="confirmCertificateType">
                <el-option v-for="item in certificateType" :key="item.id" :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码">
              <el-input v-model="item.certificateNum" />
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input v-model="item.mobile" />
            </el-form-item>
            <el-form-item v-show="false" label="行业">
              <el-input v-model="item.work" />
            </el-form-item>
            <el-form-item label="工作地址">
              <el-input v-model="item.address" />
            </el-form-item>
            <el-form-item label="与队员关系">
              <el-input v-model="item.relation" />
            </el-form-item>
          </div>
          <el-form-item>
            <el-button v-permission="['user-player-edit']" :loading="userLoding" type="primary" @click="updateGguardian()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>
      </el-tab-pane>
      
      <el-tab-pane label="就读学校" name="fifth" :disabled="!(player.category == '北京学生' || player.category == '外地学生')">
        <div class="add" style="display: flex; align-items: center;">
          <el-select v-model="enterSchoolYear" style="width: 160px; margin-right: 10px;" placeholder="选择入学年度">
            <el-option
              v-for="item in yearOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>

          <el-select
              v-if="player.category == '北京学生'"
              v-model="enterSchoolId"
              filterable
              remote
              :remote-method="getSchool"
              :loading="schoolLoading"
              placeholder="选择就读学校"
              style="
                width: 300px; margin-right: 10px;
              ">
              <el-option v-for="item in school" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>

            <el-input
                v-if="player.category == '外地学生'"
                v-model="enterSchoolName"
                placeholder="请输入学校名称"
                style="width: 300px; margin-right: 10px;"
            />

            <el-upload
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              :on-success="handleEnterSchoolCardImg"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              class="upload-demo"
              style="margin-right: 10px;">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="enterSchoolCardImg | ImageCertFormats" alt="img"></div>
                <img v-show="enterSchoolCardImg" slot="reference" :src="enterSchoolCardImg | ImageFormats" class="certificate-upload-style" >
              </el-popover>
              <div v-show="!enterSchoolCardImg" class="certificate-upload-style" >
                上传学籍卡
              </div>
            </el-upload>

          <el-button :disabled="!(enterSchoolYear && (enterSchoolId || enterSchoolName) && enterSchoolCardImg)" type="primary" @click="addPlayerSchool">添 加</el-button>

          <span style="margin-left: 6px;"> 
          <el-tooltip class="reason-item" content="请更新学籍信息" placement="top">
            <i class="el-icon-warning-outline" @click="appendRemarkReason('请更新学籍信息')"></i>
          </el-tooltip>
          </span>
        
        </div>
        <div class="table">
          <el-table
            :data="mySchoolList"
            border
            style="width: 600px; margin-top: 20px">
            <el-table-column
              prop="enterSchoolYear"
              label="入学年度"/>
            <el-table-column
              prop="schoolName"
              label="就读学校"
              width="200px"/>
            <el-table-column
              prop="studentCardImg"
              label="学籍卡">
              <template slot-scope="scope">
                    <el-popover
                        placement="top-start"
                        trigger="hover">
                        <div class="popover-content">
                            <img :src="scope.row.studentCardImg | ImageCertFormats" alt="img"/>
                        </div>
                        <img slot="reference" :src="scope.row.studentCardImg | ImageFormats" class="certificate-upload-style" />
                    </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="120">
              <template slot-scope="{row}">
                <el-link type="danger" @click="deletePlayerSchool(row)">删 除</el-link>
                <el-tooltip class="reason-item" content="学籍卡已过期" placement="top">
                    <i class="el-icon-warning-outline" @click="appendRemarkReason('学籍卡已过期(' + row.schoolName + ')')"></i>
                  </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table">
          <el-table
            :data="mySchoolChangeList"
            border
            style="width: 862px; margin-top: 20px">
            <el-table-column
              label="变更时间"
              width="160px">
              <template slot-scope="{row}">
                <span>{{ row.submitTime | dateFormatter }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="submitName"
              label="变更人员"
              width="100px"/>
            <el-table-column
              label="操作类型"
              width="80px">
              <template slot-scope="{row}">
                <span>{{ row | operatorFormatter }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="变更内容"
              width="400px">
              <template slot-scope="{row}">
                <span>{{ row | changeFormatter }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="变更理由"
              width="120px">
              <template slot-scope="{row}">
                <span>{{ row.submitReasonType | reasonFormatter }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      
      <el-tab-pane label="审核操作" name="seventh">
        <el-form v-if="membership" class="user-from" label-width="140px" >
          <el-form-item label="审核状态">
            <el-select v-model="membership.status">
              <el-option v-for="item in auditStateList" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item v-if="membership.status == 1" label="拒绝理由">
            <el-input
              :rows="4"
              v-model="membership.remark"
              type="textarea"
              placeholder="请输入未通过的原因"/>
          </el-form-item>
          <el-form-item v-if="membership.status == 1" label="不通过理由">
            <div class="reason-button-container">
                <div class="reason-button">
                    <el-button @click="appendRemarkReason('身份证已过期')">身份证已过期</el-button>
                </div>
                <div class="reason-button">
                    <el-button @click="appendRemarkReason('学籍卡已过期')">学籍卡已过期</el-button>
                </div>
                <div class="reason-button">
                    <el-button @click="appendRemarkReason('身份证需附监护人/本人（16岁以上）签字')">身份证需附监护人/本人（16岁以上）签字</el-button>
                </div>
                <div class="reason-button">
                    <el-button @click="appendRemarkReason('头像应为证件照')">头像应为证件照</el-button>
                </div>
                <div class="reason-button">
                    <el-button @click="appendRemarkReason('请更新学籍信息')">请更新学籍信息</el-button>
                </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-player-edit']" :loading="userLoding" type="primary" @click="submitMembership()" >提交</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import moment from 'moment'
import permission from '@/directive/permission/index.js' // 权限判断指令
import { varConfig, showMessage, ImageFormat, ConstConfig, getDateObjectByString } from '@/utils'
import { getQiniuUploadToken, getSchoolList, getSourceList } from '@/api/site'

import { getPlayerById, updatePlayer, updatePlayerGuardian, getPlayerExtendedInfo, getPlayerSchoolList, addSchoolRelation, addSchoolRelationChange, removeSchoolRelation, getSchoolRelationChangeList, getPlayerOrganizationList, addOrganizationRelation, removeOrganizationRelation, updateUserInfo, updatePlayerInfo, getPlayerMatchGroupList, getMembershipStatus } from '@/api/player'
import { getHistoryMembershipYear, getHistoryOrganization, getOrganizationList, getCoachList } from '@/api/user'
import { addPlayerTeamExperience, getPlayerTeamExperienceList, getPlayerTeamList, deletePlayerTeamExperience, getAuditList, updateMembershipStatus } from '@/api/user'
import ObjectFunc from '@/tbs/util/ObjectFunc'
import DateTimeFunc from '@/tbs/util/DateTimeFunc'
import { getUserInfo } from '@/utils/auth'

const certificateType = ConstConfig.certificateType

export default {
  name: 'Details',
  directives: { permission },
  filters: {
    ImageFormats(img) {
      return ImageFormat.fileView(img)
    },
    ImageCertFormats(img) {
      return ImageFormat.imageView(img, 960, 594, 2)
    },
    dateFormatter(dateTime) {
        return DateTimeFunc.formatUTCTime(dateTime)
    },
    operatorFormatter(row) {
        if (row.beforeVal && row.afterVal) {
            return '编辑'
        }
        else if (row.beforeVal) {
            return '删除'
        }
        else if (row.afterVal) {
            return '新建'
        }
    },
    resultFormatter(result) {
        let label = ''
        if (result > 0) {
            label += '第' + result + '名'
        }
        return label
    },
    changeFormatter(row) {
        const contents = []
        if (row.beforeVal && row.afterVal) {
            const prev = JSON.parse(row.beforeVal)
            const cur = JSON.parse(row.afterVal)
            if (prev.enterSchoolYear != cur.enterSchoolYear) {
                contents.push('入学年度从' + prev.enterSchoolYear + '改为' + cur.enterSchoolYear)
            }
            if (prev.schoolName != cur.schoolName) {
                contents.push('就读学校从' + prev.schoolName + '改为' + cur.schoolName)
            }
            if (prev.studentCardImg != cur.studentCardImg) {
                contents.push('学籍卡照片进行了重新上传')
            }
        }
        else if (row.beforeVal) {
            const prev = JSON.parse(row.beforeVal)
            contents.push('入学年度为' + prev.enterSchoolYear)
            contents.push('就读学校为' + prev.schoolName)
        }
        else if (row.afterVal) {
            const cur = JSON.parse(row.afterVal)
            contents.push('入学年度为' + cur.enterSchoolYear)
            contents.push('就读学校为' + cur.schoolName)
        }
        return contents.join('，')
    },
    reasonFormatter(reasonType) {
        if (reasonType == 0) {
            return '转存历史记录'
        }
        else if (reasonType == 1) {
            return '用户提交'
        }
        else if (reasonType == 2) {
            return '管理员维护'
        }
    },
  },
  data() {
    return {
      schoolLoading: false,
      activeName: 'first',
      organizationList: {},
      dataObj: { token: '' },
      qiniuUp: varConfig.qiniuUp,
      accept: ConstConfig.accept,
      playerId: '',
      player: {},
      historyYears: [],
      historyOrgs: [],
      school: [],
      certificateType: certificateType,
      userLoding: false,
      coachList: '',
      guardians: [],
      sourceList: [],
      areaList: ['北京-长期', '非北京'],
      yearOptions: [],
      year: '',
      teamId: '',
      teamList: [],
      list: [],
      schoolGradeList: [{label: '一年级', value: 1}, {label: '二年级', value: 2}, {label: '三年级', value: 3}, {label: '四年级', value: 4}, {label: '五年级', value: 5}, {label: '六年级', value: 6}, {label: '七年级', value: 7}, {label: '八年级', value: 8}, {label: '九年级', value: 9}, {label: '高一', value: 10}, {label: '高二', value: 11}, {label: '高三', value: 12}],
      enterSchoolYear: null,
      enterSchoolId: null,
      enterSchoolName: '',
      enterSchoolCardImg: null,
      mySchoolList: [],
      mySchoolChangeList: [],
      sportsLevelList: [{label: '三级运动员', value: 1}, {label: '二级运动员', value: 2}, {label: '一级运动员', value: 3}, {label: '运动健将', value: 4}, {label: '国际级运动员', value: 5}],
      enterOrganizationYear: null,
      enterOrganizationId: null,
      myOrganizationList: [],
      myGroupList: [],
      expiredDate: null,
      auditStateList: [],
      membership: {}
    }
  },
  watch: {
    'player.source': {
      handler: (val, oldVal) => { // 普通的watch监听
      }
    },
    year() {
      this.teamId = ''
      this.getPlayerTeamList()
    }
  },
  created() {
    this.playerId = this.$route.params.id
    // this.getPlayerInfo()
    this.getQiniuToken()
    this.getSchool()
    this.getOrganization()
    this.getCoachList()
    this.getMembership()
    this.sourceList = getSourceList()
    this.auditStateList = getAuditList()
    this.auditStateList.shift()
    this.year = new Date().getFullYear()
    for (let i = 0; i < 30; i++) {
      this.yearOptions.push({ value: this.year - i, label: this.year - i })
    }
  },
  mounted() {
    this.getPlayerTeamList()
    this.getPlayerTeamExperienceList()
  },
  methods: {
    appendRemarkReason(reasonText) {
        if (this.membership.status != 1) {
            this.membership.status = 1
        }
        this.membership.remark = this.membership.remark || ''
        if (this.membership.remark.indexOf(reasonText) > -1) {
            return;
        }
        else {
            let separator = '；'
            if (this.membership.remark.length == 0) {
                separator = ''
            }
            else if (this.membership.remark.charAt(this.membership.remark.length - 1) == '；') {
                separator = ''
            }
            this.membership.remark += separator + reasonText
        }
    },
    getAuditList() {

    },
    handleEnterSchoolCardImg(data) {
        this.enterSchoolCardImg = data.hash
    },
    deleteExperience(row) {
      const params = {
        playerId: this.playerId,
        teamId: row.teamId,
        year: row.year
      }
      this.$confirm('是否确认删除该经历?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deletePlayerTeamExperience(params).then(res => {
          if (res) {
            this.$message.success('删除成功')
            this.getPlayerTeamExperienceList()
          }
        })
      })
    },
    getPlayerTeamExperienceList() {
      const params = {
        playerId: this.playerId
      }
      getPlayerTeamExperienceList(params).then(res => {
        if (res) {
          this.list = res.data.list
          console.log(res.data.list)
        }
      })
    },
    addPlayerExperience() {
      if (!this.year && !this.teamId) {
        this.$message.error('请选择年度已经球队')
      }
      const params = {
        playerId: this.playerId,
        year: this.year,
        teamId: this.teamId
      }
      addPlayerTeamExperience(params).then(res => {
        if (res) {
          this.$message.success('添加成功')
          this.getPlayerTeamExperienceList()
        }
      })
    },
    deletePlayerSchool(row) {
      console.log('@deletePlayerSchool.row', row)
      const params = {
        playerSchoolId: row.id
      }
      this.$confirm('是否确认删除该条记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeSchoolRelation(params).then(res => {
          if (res) {
            this.$message.success('删除成功')
            this.getPlayerSchoolInfo(true)
            const userInfo = getUserInfo()
            addSchoolRelationChange({
                playerSchoolId: params.playerSchoolId,
                playerId: this.playerId,
                beforeVal: JSON.stringify(row),
                submitId: userInfo.id,
                submitName: userInfo.trueName,
                submitReasonType: 2
            }).then((res) => {
              if (res) {
                  console.log('@addSchoolRelationChange.res', res)
                  this.getPlayerSchoolChangeList()
              }
            })
          }
        })
      })
    },
    addPlayerSchool() {
        console.log('@addPlayerSchool', this.school.length)
        let schoolName = ''
        if (this.player.category == '北京学生') {
            for (let i = 0; i < this.school.length; i++) {
                let item = this.school[i]
                if (item.id === this.enterSchoolId) {
                    schoolName = item.name
                    break
                }
            }
        }
        else if (this.player.category == '外地学生') {
            schoolName = this.enterSchoolName
        }
        console.log('@schoolName', schoolName)
        const data = {
            enterSchoolYear: this.enterSchoolYear,
            playerId: this.playerId,
            schoolId: this.enterSchoolId ? this.enterSchoolId : 0,
            schoolName: schoolName,
            studentCardImg: this.enterSchoolCardImg
        }
        console.log('@data', data)
        addSchoolRelation(data).then(res => {
        if (res) {
          this.$message.success('添加成功')
          this.enterSchoolName = ''
          this.enterSchoolYear = null
          this.enterSchoolId = null
          this.enterSchoolCardImg = null
          this.getPlayerSchoolInfo(true)
          const userInfo = getUserInfo()
          addSchoolRelationChange({
                playerId: data.playerId,
                afterVal: JSON.stringify(data),
                submitId: userInfo.id,
                submitName: userInfo.trueName,
                submitReasonType: 2
            }).then((res) => {
              if (res) {
                  console.log('@addSchoolRelationChange.res', res)
                  this.getPlayerSchoolChangeList()
              }
            })
        }
      })
    },
    deletePlayerOrganization(row) {
        console.log('@deletePlayerOrganization.row', row)
      const params = {
        playerOrganizationId: row.id
      }
      this.$confirm('是否确认删除该条记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeOrganizationRelation(params).then(res => {
          if (res) {
            this.$message.success('删除成功')
            this.getPlayerOrganizationInfo(true)
          }
        })
      })
    },
    addPlayerOrganization() {
        console.log('@addPlayerOrganization', this.enterOrganizationYear, this.enterOrganizationId)
        let organizationName = ''
        for (let i = 0; i < this.organizationList.length; i++) {
            let item = this.organizationList[i]
            if (item.id === this.enterOrganizationId) {
                organizationName = item.name
                break
            }
        }
        console.log('organizationName', organizationName)
        const data = {
            enterOrganizationYear: this.enterOrganizationYear,
            playerId: this.playerId,
            organizationId: this.enterOrganizationId,
            organizationName: organizationName
        }
        console.log('@data', data)
        addOrganizationRelation(data).then(res => {
            if (res) {
              this.$message.success('添加成功')
              this.enterOrganizationYear = null
              this.enterOrganizationId = null
              this.getPlayerOrganizationInfo(true)
            }
        })
    },
    getPlayerTeamList() {
      const params = {
        year: this.year,
        playerId: this.playerId
      }
      getPlayerTeamList(params).then(res => {
        if (res) {
          const list = res.data.list
          this.teamList = []
          list.forEach(item => {
            this.teamList.push({ value: item.id, label: item.name })
          })
        }
      })
    },
    getSchool(name) {
      this.schoolLoading = true;
      getSchoolList({name: name || '', pageSize:9999, pageNum:1}).then((resolve) => {
        this.schoolLoading = false;
        this.school = resolve.data.list;
      }, (reject) => {
      })
    },
    getPlayerInfo() {
      getPlayerById(this.playerId).then((resolve) => {
        const player = resolve.data.player
        if (player.source) {
          if (!this.sourceList.includes(player.source)) {
            player.otherSource = player.source
            player.source = this.sourceList[3]
          }
        }
        this.player = player
        this.player.birthday = getDateObjectByString(this.player.birthday)
        if (this.player.organizationId) {
          var self = this
          var organization = _.find(this.organizationList, function(item) {
            return item.id == self.player.organizationId
          })
          this.player.organizationId = organization ? organization.id : ''
        }
        this.guardians = this.player.guardians
        if (this.guardians && this.guardians.length < 2) {
          this.guardians.push({ name: '', address: '', mobile: '', email: '', relation: '' })
        } else {
          //          this.guardians = this.guardians.reverse()
        }
        this.getHistoryMembershipYear(this.player.userId)
        this.getHistoryOrganization(this.player.userId)
        this.getPlayerMoreInfo()
        this.getPlayerSchoolInfo()
        this.getPlayerSchoolChangeList()
        this.getPlayerOrganizationInfo()
      }, (reject) => {
      })
    },
    getPlayerOrganizationInfo(needUpdate) {
        getPlayerOrganizationList({id: this.playerId}).then((data) => {
            console.log('@getPlayerOrganizationList', data)
            this.myOrganizationList = data
            if (needUpdate) {
                this.setUserManage()
            }
            getPlayerMatchGroupList({id: this.playerId}).then((res) => {
                console.log('@getPlayerMatchGroupList', res)
                const groupList = res
                let currentOrganization = ''
                for (let i = groupList.length - 1; i >= 0; i--) {
                    let group = groupList[i]
                    for (let j = data.length - 1; j >= 0; j--) {
                        let item = data[j]
                        if (group.season >= item.enterOrganizationYear) {
                            currentOrganization = item.organizationName
                        }
                    }
                    group.organizationName = currentOrganization
                }
                console.log('@groupList', groupList)
                this.myGroupList = groupList
            })
        })
    },
    getPlayerSchoolInfo(needUpdate) {
        getPlayerSchoolList({id: this.playerId}).then((data) => {
            console.log('@getPlayerSchoolList', data)
            this.mySchoolList = data
            if (needUpdate) {
                this.setUserManage()
            }
        })
    },
    getPlayerSchoolChangeList() {
        getSchoolRelationChangeList({id: this.playerId}).then((data) => {
            console.log('@getSchoolRelationChangeList', data)
            this.mySchoolChangeList = data
        })
    },
    getPlayerMoreInfo() {
        getPlayerExtendedInfo({id: this.playerId}).then((data) => {
            const player = data[0]
            if (player.expiredDate > 0) {
                this.expiredDate = new Date(player.expiredDate)
            }
            else {
                this.expiredDate = null
            }
            player.schoolGrade = player.schoolGrade ? player.schoolGrade : ''
            player.sportsLevel = player.sportsLevel ? player.sportsLevel : ''
            ObjectFunc.mergeObject(this.player, player)
        })
    },
    getMembership() {
        getMembershipStatus({id: this.playerId}).then((data) => {
            this.membership = data[0]
        })
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        showMessage('error', '上传头像图片大小不能超过 10MB!')
      }
      return isLt2M
    },
    handleSuccess(response) {
      this.$set(this.player, 'profile', response.hash)
    },
    handleCertificateFront(response) {
      this.player.certificateFrontImg = response.hash
    },
    handleCertificateBack(response) {
      this.player.certificateBackImg = response.hash
    },
    handlestudentCardImg(response) {
      this.player.studentCardImg = response.hash
    },
    handleSportsLevelImgSuccess(data) {
        this.player.sportsLevelImg = data.hash
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.dataObj.token = data.token
      }).catch(err => {
        console.log(err, 'error', '七牛Token获取失败')
      })
    },
    handleError(file) {

    },
    submitMembership() {
        updateMembershipStatus(this.membership).then((resolve) => {
        if (resolve) {
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.userLoding = false
          history.back()
        }
      }, (reject) => {
        this.userLoding = false
        this.$message.error('审核提交失败')
      })
    },
    setUserManage() {
      // ///
      const params = {
        id: this.playerId,
        profile: this.player.profile,
        trueName: this.player.trueName,
        gender: this.player.gender,
        nationality: this.player.nationality,
        birthday: this.player.birthday ? moment(this.player.birthday).format('YYYY-MM-DDTHH:mm:ss+0800') : '',
        certificateType: this.player.certificateType,
        certificateNum: this.player.certificateNum,
        certificateFrontImg: this.player.certificateFrontImg,
        certificateBackImg: this.player.certificateBackImg,
        category: this.player.category,
        // schoolId: this.player.schoolId,
        // enterSchoolYear: this.player.enterSchoolYear,
        // organizationId: this.player.organizationId,
        // studentCardImg: this.player.studentCardImg,
        area: this.player.area,
        high: this.player.high,
        weight: this.player.weight,
        email: this.player.email,
        stickHand: this.player.stickHand,
        isAbroad: this.player.isAbroad,
        abroadDate: this.player.abroadDate,
        educationSummary: this.player.educationSummary,
        team: this.player.team,
        position: this.player.position,
        jerseyNo: this.player.jerseyNo,
        coachId: this.player.coachId,
        declaredHistoryOrgnizations: this.player.declaredHistoryOrgnizations,
        declaredHistoryTeams: this.player.declaredHistoryTeams,
        athletePerformance: this.player.athletePerformance
      }
      if (this.player.source === this.sourceList[3]) {
        params.source = this.player.otherSource
      } else {
        params.source = this.player.source
      }
      if (this.myOrganizationList.length > 0) {
        // sort on the enterOrganizationYear desc
        this.myOrganizationList.sort(function(a, b) {
            return b.enterOrganizationYear - a.enterOrganizationYear
        })
        params.organizationId = this.myOrganizationList[0].organizationId
        console.log('@myOrganizationList', this.myOrganizationList, params.organizationId)
    }
    if (this.mySchoolList.length > 0) {
        // sort on the enterSchoolYear desc
        this.mySchoolList.sort(function(a, b) {
            return b.enterSchoolYear - a.enterSchoolYear
        })
        params.schoolId = this.mySchoolList[0].schoolId
        params.enterSchoolYear = this.mySchoolList[0].enterSchoolYear
        params.studentCardImg = this.mySchoolList[0].studentCardImg
    }
      // ///
      this.userLoding = true
      this.count = 0
      this.total = 3
      updatePlayer(params).then((resolve) => {
        if (resolve) {
          this.checkSubmitComplete()
        }
      }, (reject) => {
        this.userLoding = false
        this.$message.error('数据保存失败')
      })
      const userParams = {}
      if (this.expiredDate) {
          userParams.certificateExpiredDate = this.expiredDate.getTime()
      }
      else {
          userParams.certificateExpiredDate = 0
      }
      console.log('@userParams', userParams)
      updateUserInfo({id: this.player.userId}, userParams).then((res) => {
        if (res) {
          this.checkSubmitComplete()
        }
      }, (reject) => {
        this.userLoding = false
        this.$message.error('数据保存失败')
      })
      const playerParams = {}
      playerParams.schoolGrade = this.player.schoolGrade ? this.player.schoolGrade : 0
      playerParams.sportsLevel = this.player.sportsLevel ? this.player.sportsLevel : 0
      playerParams.sportsLevelImg = this.player.sportsLevelImg
      console.log('@playerParams', playerParams)
      updatePlayerInfo({id: this.player.id}, playerParams).then((res) => {
        if (res) {
          this.checkSubmitComplete()
        }
      }, (reject) => {
        this.userLoding = false
        this.$message.error('数据保存失败')
      })
    },
    checkSubmitComplete() {
      if (++this.count == this.total) {
        console.log('@submit complete')
        this.$message({
          message: '更新成功',
          type: 'success'
        })
        this.userLoding = false
      }
    },
    getHistoryMembershipYear(userId) {
      getHistoryMembershipYear(userId, 1).then(response => {
        const data = response.data
        const list = data.list
        const newList = this.getNewYearsList(list)
        this.historyYears = newList
      }).catch(err => {
      })
    },
    getNewYearsList(list) {
      const playerName = this.player.trueName
      const yearList = {
        '舒骏宇': [{ year: '2017' }, { year: '2016' }],
        '李迦南': [{ year: '2015' }, { year: '2014' }],
        '丁一': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '耿若茗': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '李以衡': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '魏圣玺': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }],
        '陈沐晗': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '刘一然': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '董云龙': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '王振博': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '张睿轩': [{ year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '张宜赫': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }],
        '马博宣': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '王奥': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }],
        '田林泽': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }],
        '陆畅': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '黄少琰': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '吴禹桐': [{ year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }]
      }
      const otherList = yearList[playerName] || []
      const newList = list.concat(otherList)
      return newList
    },
    getHistoryOrganization(userId) {
      getHistoryOrganization(userId, 1).then(response => {
        const data = response.data
        this.historyOrgs = data.list
      }).catch(err => {
      })
    },
    confirmTime(field) {
      this.player[field] = moment(this.player[field]).format('YYYY')
    },
    confirmCertificateType(val) {
    },
    getOrganization() {
      getOrganizationList().then((resolve) => {
        this.organizationList = resolve.data.list
        this.getPlayerInfo()
        // this.getPlayerMoreInfo()
      }, (reject) => {})
    },
    getCoachList() {
      getCoachList().then((resolve) => {
        this.coachList = resolve.data.list
      }, (reject) => {})
    },
    updateGguardian() {
      const param = {
        playerId: this.playerId,
        guardians: JSON.stringify(this.guardians)
      }
      updatePlayerGuardian(param).then((resolve) => {
        if (resolve) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
        } else {
          this.$message.error('数据保存失败')
        }
      })
      this.setUserManage()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .player-detail-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .upload-size .el-upload {
      width: 80px;
      height: 80px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 78px;
      height: 78px;
      line-height: 78px !important;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
    }

    .upload-size .el-upload:hover {
      border-color: #409EFF;
    }

    .upload-size .el-upload-list li {
      width: 80px;
      height: 80px;
    }

    .label-line-height .el-form-item__label {
      line-height: 80px;
      text-align: center;
    }

    /*.user-from, .lce-hockey-level, .hockey-contact {*/
      /*width: 800px;*/
    /*}*/

    .user-from .el-form-item__label {
      text-align: left;
      padding-left: 15px;
    }

    .certificate-upload-style {
      width: 120px;
      height: 32px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      color: #999999;
      line-height: 32px;
    }

    .font-size-style {
      font-size: 14px;
      color: #169BD5;
      padding-left: 20px;
    }

    .team-info-width {
      width: auto;
      margin-right: 12px;
    }

    .el-upload img {
      width: 78px;
      height: 78px;
    }

    .guardians {
      border-bottom: 1px solid #ccc;
      margin-bottom:17px;
      width: 600px;
    }

    .guardians:nth-child(2) {
      border-bottom: none;
    }

    .el-input--small {
      max-width: 300px;
    }

    .el-dropdown {
      cursor: pointer;
    }

  }

  .el-popover .popover-content img {
    max-width: 360px;
  }

  .reason-button {
    margin-bottom: 6px;
  }
</style>
